import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["cellPhone"]
  }

  // Helper method to get cell phone field (with fallback)
  getCellPhoneField() {
    // Try to find the cell phone field in the document
    return document.querySelector('input[name="user[cell_phone]"]')
  }

  connect() {
    // Controller connected
  }

  disconnect() {
    // Controller disconnected
  }
}
